import { useQuery, UseQueryResult } from "react-query"
import sanityClient from "../api/sanity-client"
import { SanityLocale } from "../sanity/sanity-types"
import { useConfig } from "./use-config"

const useSanityContent = <T>(
    fetchKey: string,
    query: string,
    queryArgs: Record<string, string | number>,
    sanityLocale: SanityLocale,
): UseQueryResult<T> => {
    const config = useConfig()
    return useQuery<T>(
        ["useSanityContent", fetchKey],
        () => sanityClient(config).fetch(query, { lang: sanityLocale, ...queryArgs }),
        {
            refetchOnMount: false,
        },
    )
}

export default useSanityContent
